import { E164ToNational } from '@x1/util-format';

import CreditApplicationPageLayout from 'src/components/creditApplication/CreditApplicationPageLayout';

interface PropsIface {
  e164?: string;
}

const LandlinePage = ({ e164 }: PropsIface) => {
  return (
    <CreditApplicationPageLayout
      showLogo={false}
      title='Thank you'
      subtitle={`A team member will call ${
        e164 ? E164ToNational(e164) : 'your fraud alert phone number'
      } within 7 days to verify your identity. You can then proceed with your application.`}
    />
  );
};

export default LandlinePage;
